import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const PageWrapper = styled.div`
  width: 100%;
  padding-left: ${({ drawerWidth, isMobile }) => (drawerWidth && !isMobile ? `${drawerWidth}px` : 0)};
  transition: padding 0.5s;
  background-color: #f6f8fb;

  ${theme.breakpoints.down('md')} {
    padding: initial;
  }
`

export const Container = styled.div`
  padding: 0px 40px 30px;
  min-height: 100vh;
  margin: 0 auto;
  background-color: #f6f8fb;

  ${theme.breakpoints.down('md')} {
    padding: initial;
  }
`

export const HeaderContainer = styled.div`
  padding: 25px 0 25px;
  width: 75%;
  max-width: 900px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #cfcfcf;

  ${theme.breakpoints.down('md')} {
    padding: 0 0 0 70px;
    min-height: 70px;
    width: 100%;
    max-width: 100%;
  }
`

export const Header = styled.p`
  margin: 0;
  font-size: 24px;
  line-height: 24px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  color: ${theme.colors.blue900};

  ${theme.breakpoints.down('md')} {
    font-size: 16px;
  }
`

export const TableWrapper = styled.div`
  max-width: 1500px;

  ${theme.breakpoints.down('md')} {
    padding: 0 16px;
  }
`
